import { render, staticRenderFns } from "./PresetVenueDetails.vue?vue&type=template&id=17540e22&"
import script from "./PresetVenueDetails.vue?vue&type=script&lang=js&"
export * from "./PresetVenueDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports